import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./styles/Thankyou.css";
import { PARAMS } from '../api/axiosConfig';

export default function MerchantConsentThankYou() {
  const [searchParams] = useSearchParams();
  const ticketId = searchParams.get(PARAMS.TICKET_ID) || "";

  return (
    <div className="container">
      <div className="card">
        <div className="icon-success">✓</div>
        <h1>Thank You!</h1>
        <p>
          Ticket ID: <span className="ticket-id">#{ticketId}</span> is marked as <strong>Closed Pay</strong>.
        </p>
        <p>
          Our team has updated the ticket status to <strong>Closed Pay</strong> after merchant dispute accepted. No further action is required.
        </p>
        <ul>
          <li>
            <strong>Status:</strong> Closed Pay
          </li>
        </ul>
      </div>
      <footer>
        <p>HubSpot Dispute Resolution Portal &copy; 2025</p>
      </footer>
    </div>
  );
}
